import { defineStore } from 'pinia'
import { getUserInfo } from '@/lib/api'

export const useRoleStore = defineStore('role', {
  state: () => ({
    tempRole: null,
    isSchoolAdmin: false,
    isGradeAdmin: false,
    isGradeLeader: false,
    hasGradingAccess: false,
    // 채점 결과 확인 및 피드백 등록 접근 판정용(tb_user_priv_info.tea_role):
    //  CT = 담임(자기 반 전 과목), P/VP = 교장/교감(학교 전 학년). 소속 스코프도 함께 보관.
    teaRole: '',
    homeroomGrade: '',   // 담임 반 학년 (grade_code)
    homeroomClass: '',   // 담임 반 (school_cls)
    schulCode: '',
    schoolType: '',      // sch_lvl (orgType: E/M/H)
  }),

  getters: {
    // 담임 교사(자기 반의 국영수사과 전체를 볼 수 있음)
    isHomeroomTeacher: (state) => state.tempRole === 'teacher' && state.teaRole === 'CT',
    // 교장/교감(학교의 모든 학년을 볼 수 있음)
    isPrincipalOrVice: (state) =>
      state.tempRole === 'teacher' && (state.teaRole === 'P' || state.teaRole === 'VP'),
    // 채점 결과 확인 및 피드백 등록 탭 접근 가능 대상:
    //  1차 채점자 등 채점 권한자 + 담임(CT) + 교장/교감(P/VP).
    //  ※ 학교 관리자는 이 탭 권한이 없다(제외). 채점자/담임/교장·교감을 겸하면 그 자격으로 접근.
    canViewFeedback() {
      return (
        this.tempRole === 'teacher' &&
        (this.hasGradingAccess || this.isHomeroomTeacher || this.isPrincipalOrVice)
      )
    },
  },

  actions: {
    setRoleFromUserInfo() {
      const userInfo = getUserInfo()
      console.log('setRoleFromUserInfo called with:', userInfo)

      if (userInfo && Object.keys(userInfo).length > 0 && userInfo.role) {
        // Map API roles to store roles
        this.tempRole = userInfo.role === 'tea' ? 'teacher' : userInfo.role === 'stu' ? 'student' : null
        this.isSchoolAdmin = userInfo.isSchoolAdmin === 'Y'
        this.isGradeAdmin = userInfo.isGradeAdmin === 'Y'
        this.isGradeLeader = userInfo.isLeader === 'Y' || userInfo.isGradeLeader === 'Y'
        this.hasGradingAccess = userInfo.hasGradingAccess === 'Y' || this.isGradeAdmin
        this.teaRole = userInfo.teaRole || ''
        this.homeroomGrade = userInfo.grade || ''
        this.homeroomClass = userInfo.classroom || ''
        this.schulCode = userInfo.schulCode || ''
        this.schoolType = userInfo.orgType || ''
        if (this.tempRole !== 'teacher') {
          this.hasGradingAccess = false
          this.teaRole = ''
        }
        console.log('Role set to:', this.tempRole, 'isSchoolAdmin:', this.isSchoolAdmin, 'isGradeAdmin:', this.isGradeAdmin, 'isGradeLeader:', this.isGradeLeader, 'teaRole:', this.teaRole)
      } else {
        console.log('No valid userInfo found, clearing role')
        this.clearRole()
      }
    },

    clearRole() {
      this.tempRole = null
      this.isSchoolAdmin = false
      this.isGradeAdmin = false
      this.isGradeLeader = false
      this.hasGradingAccess = false
      this.teaRole = ''
      this.homeroomGrade = ''
      this.homeroomClass = ''
      this.schulCode = ''
      this.schoolType = ''
    }
  }
})
